import { render, staticRenderFns } from "./OperatorMenu.vue?vue&type=template&id=b1dc12ca&scoped=true"
import script from "./OperatorMenu.vue?vue&type=script&lang=js"
export * from "./OperatorMenu.vue?vue&type=script&lang=js"
import style0 from "./OperatorMenu.vue?vue&type=style&index=0&id=b1dc12ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dc12ca",
  null
  
)

export default component.exports